var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTether(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1315_5501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.583 24.916C5.72495 24.916 0.166016 19.3571 0.166016 12.499C0.166016 5.64096 5.72495 0.0820312 12.583 0.0820312C19.4411 0.0820312 25 5.64096 25 12.499C25 19.3571 19.4411 24.916 12.583 24.916ZM14.0746 10.7863V8.95009H18.2762V6.15006H6.83627V8.95009H11.0379V10.7855C7.6232 10.9422 5.05521 11.619 5.05521 12.4292C5.05521 13.2394 7.6232 13.9153 11.0379 14.0729V19.957H14.0746V14.0713C17.4838 13.9146 20.0456 13.2386 20.0456 12.4292C20.0456 11.6197 17.4838 10.9438 14.0746 10.7863ZM14.0746 13.5723V13.5708C13.9892 13.577 13.5492 13.6034 12.5675 13.6034C11.7837 13.6034 11.2319 13.5801 11.0379 13.5708V13.5731C8.02054 13.4404 5.76841 12.915 5.76841 12.2864C5.76841 11.6585 8.02054 11.1332 11.0379 10.9981V13.05C11.235 13.064 11.8 13.0974 12.5807 13.0974C13.5174 13.0974 13.9869 13.0586 14.0746 13.0508V10.9997C17.0857 11.1339 19.3324 11.6593 19.3324 12.2864C19.3324 12.915 17.0857 13.4388 14.0746 13.5723V13.5723Z",
    fill: "#26A17B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1315_5501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.834,
    height: 24.834,
    fill: "white",
    transform: "translate(0.166016 0.0820312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/tether.6e484ee208df53d005d88ca56d0c0750.svg";
export { ForwardRef as ReactComponent };